export default "__VITE_ASSET__c0792d9a__"